import React from "react";
import BaseButton from "@components/library/UI/BaseButton";
import "./LandingButton.sass";

const LandingButton = ({
  kind = "signup",
  variant = "primary",
  disabled = false,
  className = "",
  children,
  ...props
}) => {
  const baseClass =
    kind === "login" ? "login-button" : "signup-button";
  const variantClass = disabled
    ? `${baseClass}--disabled`
    : `${baseClass}--${variant}`;
  const classes = `${baseClass} ${variantClass} ${className}`.trim();
  const textClass =
    kind === "login" ? "login-button__text" : "signup-button__text";

  return (
    <BaseButton className={classes} disabled={disabled} {...props}>
      <span className={`whitespace-nowrap ${textClass}`}>{children}</span>
    </BaseButton>
  );
};

export default LandingButton;
